import { jsx as _jsx } from "react/jsx-runtime";
import { IconProvider } from "@ant-design/icons";
import { App, ConfigProvider } from "antd";
import "../style/formFields.scss";
import { RootStore } from "../store/stores.js";
import { antdTheme } from "../style/antdTheme.js";
const IMPREZA_BUTTON_PROPS = {
    className: "w-btn"
};
const Provider = ({ children, configProvider = {}, app = {} })=>/*#__PURE__*/ _jsx(ConfigProvider, {
        prefixCls: process.env.ANTD_PREFIX,
        iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
        theme: antdTheme,
        ...configProvider,
        children: /*#__PURE__*/ _jsx(IconProvider, {
            value: {
                prefixCls: `${process.env.ANTD_PREFIX}-anticon`
            },
            children: /*#__PURE__*/ _jsx(App, {
                message: {
                    top: 150
                },
                ...app,
                children: /*#__PURE__*/ _jsx(RootStore.StoreProvider, {
                    children: children
                })
            })
        })
    });
export { Provider, IMPREZA_BUTTON_PROPS };
